import { gql } from "@apollo/client";
import { DEDUCTION_FRAGMENT } from "./deductionFragment";

const UPDATE_DEDUCTION_INTELLIGENCE = gql`
  ${DEDUCTION_FRAGMENT}
  mutation UpdateDeductionIntelligence($params: UpdateDeductionIntelligenceParams!) {
    updateDeductionIntelligence(params: $params) {
      ...DeductionFields
    }
  }
`;

export default UPDATE_DEDUCTION_INTELLIGENCE;
